export default {"src":"/_next/static/media/brain_24.d93db412.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};